import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const companyInfo = {
    name: 'Balcony Glazing Pro s.r.o.',
    address: 'Hlavná 123, 811 01 Bratislava',
    phone: '+421 905 123 456',
    email: 'info@balconyglazingpro.sk',
    ico: '12 345 678',
    dic: '2023456789',
    bankAccount: 'SK89 1100 0000 0026 1234 5678'
  };

  const services = [
  'Zasklenie balkónov',
  'Zasklenie terás',
  'Zimné záhrady',
  'Bezrámové zasklenie',
  'Hliníkové systémy',
  'Bezpečnostné sklo'];


  const serviceAreas = [
  'Bratislava a okolie',
  'Košice a okolie',
  'Žilina a okolie',
  'Nitra a okolie',
  'Prešov a okolie',
  'Banská Bystrica a okolie'];


  const certifications = [
    {
      name: 'ISO 9001:2015',
      description: 'Systém manažérstva kvality',
      icon: 'BadgeCheck',
      iconColor: 'text-emerald-400'
    },
    {
      name: 'CE Označenie',
      description: 'Európska zhoda produktov',
      icon: 'ShieldCheck',
      iconColor: 'text-blue-400'
    },
    {
      name: 'Živnostenský list',
      description: 'Oprávnenie na podnikanie',
      icon: 'ScrollText',
      iconColor: 'text-amber-400'
    }
  ];


  const socialLinks = [
  { name: 'Facebook', icon: 'Facebook', url: '#' },
  { name: 'Instagram', icon: 'Instagram', url: '#' },
  { name: 'YouTube', icon: 'Youtube', url: '#' },
  { name: 'LinkedIn', icon: 'Linkedin', url: '#' }];


  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo?.phone}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo?.email}`;
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/+421905123456?text=Dobrý deň, mám záujem o zasklenie balkóna.`, '_blank');
  };

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Home" size={24} color="white" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-white">
                  Balcony Glazing Pro
                </h3>
                <p className="text-white/80 text-sm">
                  24 rokov skúseností
                </p>
              </div>
            </div>
            
            <p className="text-white/90 font-body mb-6 leading-relaxed">
              Sme špecialisti na zasklievanie balkónov a terás s viac ako 24-ročnou 
              skúsenosťou. Poskytujeme komplexné riešenia pre celé Slovensko.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <button
                onClick={handlePhoneClick}
                className="flex items-center space-x-3 text-white/90 hover:text-white transition-smooth">

                <Icon name="Phone" size={18} />
                <span className="font-body text-white">{companyInfo?.phone}</span>
              </button>
              
              <button
                onClick={handleEmailClick}
                className="flex items-center space-x-3 text-white/90 hover:text-white transition-smooth">

                <Icon name="Mail" size={18} />
                <span className="font-body text-white">{companyInfo?.email}</span>
              </button>
              
              <div className="flex items-start space-x-3 text-white/90">
                <Icon name="MapPin" size={18} className="mt-1 flex-shrink-0 text-white" />
                <span className="font-body text-white">{companyInfo?.address}</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              {socialLinks?.map((social) =>
              <a
                key={social?.name}
                href={social?.url}
                className="w-10 h-10 text-white bg-white/10 rounded-full flex items-center justify-center hover:bg-accent transition-smooth"
                aria-label={social?.name}>

                  <Icon name={social?.icon} size={20} />
                </a>
              )}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-6 text-white">
              Naše služby
            </h4>
            <ul className="space-y-3">
              {services?.map((service, index) =>
              <li key={index}>
                  <a
                  href="#services"
                  className="text-white/90 hover:text-white transition-smooth font-body flex items-center space-x-2">

                    <Icon name="ChevronRight" size={14} />
                    <span className="text-white">{service}</span>
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-6 text-white">
              Oblasti pôsobenia
            </h4>
            <ul className="space-y-3">
              {serviceAreas?.map((area, index) =>
              <li key={index}>
                  <a
                  href="#service-area"
                  className="text-white/90 hover:text-white transition-smooth font-body flex items-center space-x-2">

                    <Icon name="MapPin" size={14} />
                    <span className="text-white">{area}</span>
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Quick Contact */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-6 text-white">
              Rýchly kontakt
            </h4>
            
            <div className="space-y-4">
              <button
                onClick={handlePhoneClick}
                className="w-full bg-accent hover:bg-accent/90 text-white px-4 py-3 rounded-lg font-semibold transition-smooth flex items-center justify-center space-x-2">

                <Icon name="Phone" size={20} />
                <span className="text-white">Zavolať teraz</span>
              </button>
              
              <button
                onClick={handleWhatsAppClick}
                className="w-full bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-lg font-semibold transition-smooth flex items-center justify-center space-x-2">

                <Icon name="MessageCircle" size={20} />
                <span className="text-white">WhatsApp</span>
              </button>
              
              <button
                onClick={() => {
                  const element = document.querySelector('#quote-form');
                  if (element) {
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="w-full bg-white/10 hover:bg-white/20 text-white border border-white/30 px-4 py-3 rounded-lg font-semibold transition-smooth flex items-center justify-center space-x-2">

                <Icon name="Calculator" size={20} />
                <span className="text-white">Cenový odhad</span>
              </button>
            </div>

            {/* Business Hours */}
            <div className="mt-6 p-4 bg-white/10 rounded-lg">
              <h5 className="font-semibold mb-3 flex items-center space-x-2 text-white">
                <Icon name="Clock" size={18} />
                <span className="text-white">Pracovné hodiny</span>
              </h5>
              <div className="space-y-1 text-sm text-white/90">
                <div className="flex justify-between">
                  <span className="text-white">Po - Pia:</span>
                  <span className="text-white">8:00 - 17:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Sobota:</span>
                  <span className="text-white">9:00 - 14:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Nedeľa:</span>
                  <span className="text-white">Zatvorené</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Certifications & Trust Badges */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center mb-8">
            <h4 className="text-lg font-heading font-semibold mb-4 text-white">
              Certifikácie a oprávnenia
            </h4>

            <div className="flex flex-wrap justify-center items-center gap-8">
              {certifications?.map((cert, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                    <Icon
                      name={cert.icon}
                      size={28}
                      className={cert.iconColor}
                      // если твой AppIcon не принимает className — используй color="currentColor"
                      // и оберни в <span className={cert.iconColor}> <Icon ... color="currentColor" /> </span>
                    />
                  </div>
                  <div className="text-sm font-semibold text-white">{cert.name}</div>
                  <div className="text-xs text-white/80">{cert.description}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="flex flex-col items-center">
              <Icon name="Shield" size={32} color="var(--color-accent)" className="mb-2" />
              <div className="text-sm font-semibold text-orange-500">Záruka až 10 rokov</div>
            </div>
            <div className="flex flex-col items-center">
              <Icon name="Truck" size={32} color="var(--color-accent)" className="mb-2" />
              <div className="text-sm font-semibold text-orange-500">Doprava zadarmo</div>
            </div>
            <div className="flex flex-col items-center">
              <Icon name="Users" size={32} color="var(--color-accent)" className="mb-2" />
              <div className="text-sm font-semibold text-orange-500">2000+ zákazníkov</div>
            </div>
            <div className="flex flex-col items-center">
              <Icon name="Clock" size={32} color="var(--color-accent)" className="mb-2" />
              <div className="text-sm font-semibold text-orange-500">Odpoveď do 2h</div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-sm text-white/80">
              © {currentYear} {companyInfo?.name}. Všetky práva vyhradené.
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="#" className="text-white/80 hover:text-white transition-smooth">
                Ochrana osobných údajov
              </a>
              <a href="#" className="text-white/80 hover:text-white transition-smooth">
                Obchodné podmienky
              </a>
              <a href="#" className="text-white/80 hover:text-white transition-smooth">
                Reklamačný poriadok
              </a>
            </div>

            {/* Company Details */}
            <div className="text-xs text-white/60 text-center md:text-right">
              <div className="text-white">IČO: {companyInfo?.ico}</div>
              <div className="text-white">DIČ: {companyInfo?.dic}</div>
            </div>
          </div>
        </div>
      </div>
      {/* Google Maps Integration */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-8">
          <h4 className="text-lg font-heading font-semibold mb-4 text-center text-white">
            Naša poloha
          </h4>
          <div className="bg-white/10 rounded-lg overflow-hidden" style={{ height: '300px' }}>
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="Balcony Glazing Pro - Bratislava"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=48.1486,17.1077&z=14&output=embed"
              className="border-0" />

          </div>
          <div className="text-center mt-4">
            <p className="text-white/90 text-sm">
              Navštívte našu predajňu v Bratislave alebo si dohodnite bezplatné zameranie priamo u vás doma.
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default FooterSection;